import request from '@/services/api'
import { useAnalyticsStore } from '@/store/app'

async function getUser() {
  const analyticsStore = useAnalyticsStore()

  const path = '/users/me'

  try {
    const response = await request(path, {
      method: 'GET',
      headers: {
        'Application-Version': '2.15.0',
        Platform: 'web',
        'Deep-Link-Params': Object.entries(analyticsStore.queryParams)
          .map(([key, value]) => `${key}=${value}`)
          .join(',')
      }
    })

    const data = await response.json()
    // console.log('Success:', data)
    return data
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

async function updateUserSettings(postData: any) {
  const path = '/users/me/settings'

  try {
    const response = await request(path, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Application-Version': '2.15.0',
        Platform: 'web'
      },
      body: JSON.stringify(postData)
    })

    const data = await response.json()
    // console.log('Success:', data)
    return data
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

async function setUserCenter(postData: any) {
  const path = '/schools/users/center'

  try {
    const response = await request(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postData)
    })

    const data = await response.json()
    // console.log('Success:', data)
    return data
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

export default { getUser, setUserCenter, updateUserSettings }
